module.exports = __webpack_public_path__ + "static/media/k3-promo.fee274a0.png";